<template>
  <div class="top-view">
    <div class="title">
      안녕하세요 : )
    </div>
    <div class="sub-title">
      초긍정
      <div class="name-job">
        <ul class="name-job-list">
            <li>개발자</li>
            <li>기획자</li>
            <li>개발자</li>
            <li>기획자</li>
            <li>개발자</li>
        </ul>
      </div>
      다빈
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopView',
  data: () => {
    return {
    }
  },
  components: {
  }
}
</script>

<style scoped>
@keyframes rolling {
    0% {
        transform: translateY(0);
    }
    25% {
        transform: translateY(-20%);
    }
    50% {
        transform: translateY(-40%);
    }
    75% {
        transform: translateY(-60%);
    }
    100% {
        transform: translateY(-80%);
    }
}
.top-view {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 100px;
  margin-top: 60px;
}
.title {
  margin: 20px 8px;
  font-size: 1.2rem;
  font-weight: 500;
}
.sub-title {
  font-size: 1.8rem;
}
.name-job {
  display: inline-block;
  vertical-align: top;
  height: 1em;
  overflow: hidden;
  position: relative;
}
.name-job::after {
  content: ' ';
  position: absolute;
  left: 0;
  top:0;
  right: 0;
  bottom: 0;
  box-shadow: inset 0 0 1px 1px white;
}
.name-job-list {
  margin: 0;
  padding-left: 8px;
  padding-right: 0px;
  list-style: none;
  animation-name: rolling;
  animation-duration: 8.0s;
  animation-iteration-count: infinite;
  animation-direction: reverse;
}
</style>
